import React from "react"
import styled from "styled-components"
import { withAuthProvider } from "../../lib/auth"
import { Theme, SecondaryNav } from "@pga/pga-component-library"
import navigationFor from "./NavOptions"
import { flags, useFeatureFlags } from "../../lib/feature-flags"

export const SubNavFrame = styled.div`
  @media (max-width: 997.98px) {
    width: 100%;
    box-shadow: 0 5px 10px 0 ${Theme.colors.primaryShadow};
  }
`

export const SubNavigation = ({ me, loading }) => {
  const [isCareerProfileDashboardEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_CAREER_PROFILE_DASHBOARD,
  ])

  return !loading ? (
    <SubNavFrame>
      <SecondaryNav
        options={navigationFor(me, {
          isCareerProfileDashboardEnabled,
        })}
        title="My Account"
        menuTitle="Account Menu"
      />
    </SubNavFrame>
  ) : null
}

export default withAuthProvider(SubNavigation)
